import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBh = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1500 900", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h1500v900H0", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M1500 0H375l225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90h1125", fill: "#ce1126" }));
const ForwardRef = forwardRef(SvgBh);
const Memo = memo(ForwardRef);
export default Memo;
